/**
 * Service for listing to document User Interaction events such as keyboard events.
 */
export interface DocumentInteractionService {
  subscribeToKeyDown: (callback: (event: any) => void) => void;
  subscribeToKeyUp: (callback: (event: any) => void) => void;
}

export class DocumentInteractionServiceImplementation implements DocumentInteractionService {
  private onKeyDownCallBacks: ((event: any) => void)[] = [];
  private onKeyUpCallBacks: ((event: any) => void)[] = [];
  // @ngInject
  constructor($rootScope: ng.IRootScopeService) {
    let $doc = angular.element(document);
    let keyDownBinding = this.keyDown.bind(this);
    let keyUpBinding = this.keyUp.bind(this);
    $doc.on("keydown", keyDownBinding);
    $doc.on("keyup", keyUpBinding);
    $rootScope.$on("$destroy", () => {
      $doc.off("keydown", keyDownBinding);
      $doc.off("keyup", keyUpBinding);
    });
  }

  private keyDown(event: any) {
    this.onKeyDownCallBacks.forEach((callback: (event: any) => void) => {
      callback(event);
    });
  }

  private keyUp(event: any) {
    this.onKeyUpCallBacks.forEach((callback: (event: any) => void) => {
      callback(event);
    });
  }

  public subscribeToKeyDown(callback: (event: any) => void) {
    this.onKeyDownCallBacks.push(callback);
  }
  public subscribeToKeyUp(callback: (event: any) => void) {
    this.onKeyUpCallBacks.push(callback);
  }
}
